import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const skuCatalogSyncSocket = io(`${socketBaseUrl}/sku-catalog-sync`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default skuCatalogSyncSocket;
